import appStore from 'store';
import api from './api';
import {

  QUERY_TYPE,
  PAGINATION
} from './constants';

const store = {
  namespaced: true,
  state: {
    userList: [],
    detailList: [],
    coinList: [],
    symbolList: [],
    totalCount: 0,
    detailTotalCount: 0,
    pagination: PAGINATION,
    buyAmount:0,
    sellAmount:0,
    transferAmount:0

  },
  getters: {

  },
  mutations: {
    setUserList(state, payload) {
      state.userList = payload.list?payload.list.slice():[];
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setDetailList(state, payload) {
      state.detailList = payload.page.records;
      state.detailTotalCount = payload.page.total;
      state.buyAmount=payload.buyAmount
      state.sellAmount=payload.sellAmount
      state.transferAmount=payload.transferAmount
    },
    setCoinList(state,payload){
      state.coinList=payload||[]
    },
    setSymbolList(state,payload){
      state.symbolList=payload||[]
    },

  },
  actions: {
    list({ commit }, query = {}) {
      commit('setPagination', { page: query.page, size: query.size });
      api.getUserList(query).then(res => {
        if(res.code==0){
          commit('setUserList', res.data);
        }
      });
    },
    exportExcel({commit},data){
     return api.exportExcel(data).then(res=>{
        return res
      })
    },
    addRemark({commit},data){
     return api.addRemark(data).then(res=>{
        return res
      })
    },
    getDetail({commit},data){
      api.getDetail(data).then(res=>{
        if(res.code==0){
          commit('setDetailList', res.result);
        }
      })
    },
    getCoinList({commit},data){
      api.getCoinList().then(res=>{
        if(res.code==0){
          commit('setCoinList',res.result)
        }
      })
    },
    getSymbolList({commit},data){
      api.getSymbolList().then(res=>{
        if(res.code==0){
          commit('setSymbolList',res.data)
        }
      })
    },
    
 
  }
};

appStore.registerModule('currentDelegation', store);
